export default {
	supplymarketing: {
		title: '供销平台',
		search_platform: '搜索平台',
		contact: '联系方式：',
		look_case: '查看案例',
		entry_app: '入驻申请',
	},
}
